"use client";
import { jsxs as o, jsx as a } from "react/jsx-runtime";
const n = ({
  title: l,
  titleId: r,
  desc: e,
  descId: i,
  ...t
}) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": r,
    "aria-describedby": i,
    ...t,
    children: [
      e ? /* @__PURE__ */ a("desc", { id: i, children: e }) : null,
      l ? /* @__PURE__ */ a("title", { id: r, children: l }) : null,
      /* @__PURE__ */ a(
        "path",
        {
          stroke: "currentColor",
          strokeWidth: 0.8,
          d: "M23.788 26.994a12.511 12.511 0 0 1-15.575 0 .5.5 0 0 1 .624-.782 11.544 11.544 0 0 0 14.327 0 .5.5 0 0 1 .624.782ZM20.218 6.49a11.48 11.48 0 0 1 7.164 12.405.502.502 0 0 0 .618.563.5.5 0 0 0 .372-.418 12.48 12.48 0 0 0-7.788-13.48.5.5 0 0 0-.366.93ZM4.124 19.477a.5.5 0 0 0 .495-.576 11.483 11.483 0 0 1 7.164-12.41.5.5 0 0 0-.366-.93A12.482 12.482 0 0 0 3.63 19.054a.5.5 0 0 0 .494.423Zm8.974-12.383V3.289a1 1 0 0 1 1-1h3.805a1.001 1.001 0 0 1 1 1v3.805a1 1 0 0 1-1 1h-3.805a1.001 1.001 0 0 1-1-1Zm1 0h3.806l-.001-3.805h-3.805zM8.696 24.77l-3.294 1.902a1 1 0 0 1-1.366-.366l-1.903-3.294a1.002 1.002 0 0 1 .367-1.367l3.294-1.902a1.003 1.003 0 0 1 1.367.366l1.902 3.295a1.005 1.005 0 0 1-.367 1.366Zm-.5-.866L6.295 20.61 3 22.512l1.902 3.295 3.295-1.902Zm21.67-.893-1.9 3.296a1.006 1.006 0 0 1-.87.5.984.984 0 0 1-.495-.135l-3.295-1.9a1.004 1.004 0 0 1-.37-1.366l1.905-3.295a1.003 1.003 0 0 1 1.365-.37l3.296 1.905a1.003 1.003 0 0 1 .364 1.365Zm-.864-.5-3.296-1.9-1.9 3.29 3.295 1.905 1.9-3.295Z"
        }
      )
    ]
  }
);
export {
  n as default
};
